module.exports = __webpack_public_path__ + "static/q1-326a77263de1c2ae140b1215ca50667c.jpg";